import { render, staticRenderFns } from "./latest-news-cmp.vue?vue&type=template&id=fa50a06c"
import script from "./latest-news-cmp.vue?vue&type=script&lang=js"
export * from "./latest-news-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports